export type StateType = {
  id: string;
  value?: any;
};

type RequestLineType = {
  state: StateType[];
  line_ref: string;
};

export type RequestQuestionsType = {
  lines: RequestLineType[];
  productId: string;
};

type AnswerType = {
  displayName: string;
  id: string;
  priority: number;
};

type MetaDataType = {
  key: string;
  value?: any;
};

export type QuestionType = {
  allowMultiplePerClaim: boolean;
  answers: AnswerType[];
  displayName: string;
  id: string;
  metadata: MetaDataType[];
  possibleAnswers: string[];
  priority: number;
  source: string;
  type: string;
};

type TargetType = {
  args: any[];
  test: string;
};

type OutputType = {
  id: string;
  line_ref?: string;
  metadata: MetaDataType[];
  minMax?: string;
  scope: string;
  source: string;
  target: TargetType;
  type: string;
  unit?: string;
  value: number;
  valueDisplayName?: string;
  valueType: string;
};

type GlobalType = {
  result: any[];
  status: string;
  outputs: OutputType[];
};

type ResponseLineType = {
  lineRef: StateType[];
  status: string;
  result: any[];
  equivalent: boolean;
  match: boolean;
  outputs: OutputType[];
};

type ResultType = {
  global: GlobalType;
  lines: ResponseLineType[];
};

type CoverageResponseType = {
  result: ResultType;
  titleSegments: any[];
} & Pick<AnswerType, 'priority'>;

export type ResponseQuestionsType = {
  questions: QuestionType[];
  nextQuestion: QuestionType;
  coverageResponses: CoverageResponseType[];
};

export type DecisionTreeState = any;

export enum DecisionTreeType {
  DIAGNOSIS = 'diagnosis',
  SERVICE = 'services',
}

export enum ConfigDecisionTreeType {
  COMPUTABLE_CONTRACTS = 'computableContracts',
  ETL = 'etl',
}

export enum DTAnswerTypes {
  BOOLEAN = 'boolean',
  DATE = 'date',
  ENUM = 'enum',
  LOCATION = 'location',
  NUMBER = 'number',
  TEXT = 'text',
}

export type CurrentStepAnswerType = {
  displayName: string;
  icon?: string;
  id: string;
  priority: number;
  primaryKey?: string;
  columns?: { [_: string]: string };
  metadata?: { [_: string]: string }[];
};

export type DecisionTreeCurrentStepState = {
  currentOption: {
    id: string;
    answers: CurrentStepAnswerType[];
    metadata: MetaDataType[];
    type: DTAnswerTypes;
    allowMultiplePerClaim?: boolean;
    priority?: number;
    displayName?: string;
    source?: string;
    possibleAnswers?: string[];
  };
  ready: boolean;
};

type LocalDecisionTree = {
  nextQuestion: QuestionType;
  coverageResponses: CoverageResponseType[];
  givenAnswers: { [_: string]: LocalDecisionTree };
};

export type GenericLocalDecisionTree = Partial<
  LocalDecisionTree & {
    result: {};
    actualPath: pathStep[];
    questions: QuestionType[];
  }
>;

export type LocalServiceTree = LocalDecisionTree & {
  actualPath: pathStep[];
  questions: QuestionType[];
};

type pathStep = {
  id: string;
  value: string;
  answerText?: string;
  questionText?: string;
};

export type LocalDecisionTreeState = {
  diagnosis: Partial<LocalDecisionTree> & {
    result: {};
    actualPath: pathStep[];
  };
  currentCheckUpService?: string;
  currentServices: string[];
  currentService: string;
  currentDT: DecisionTreeType;
  currentPath: pathStep[];
  currentIcon: { [_: string]: string };
  interventionObjectsContext: StateType[];
  lastAnswers: { [_: string]: string };
  packageOptions: string[];
  services: { [_: string]: LocalServiceTree };
};
